var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return true
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "my-5",
            attrs: {
              role: "menu",
              "aria-orientation": "vertical",
              "aria-labelledby": "menu-button",
              tabindex: "-1",
              id: "filter-form",
            },
          },
          [
            _c(
              "div",
              [
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "mb-5" },
                      [
                        _c(
                          "FormGroup",
                          {
                            staticClass: "from-group jb-desgin",
                            attrs: { title: "Name" },
                          },
                          [
                            _c("ContractorMultiSelector", {
                              attrs: { placeholder: "Select" },
                              model: {
                                value: _vm.filterFields.users,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterFields, "users", $$v)
                                },
                                expression: "filterFields.users",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "FormGroup",
                      {
                        staticClass: "mb-4 from-group",
                        attrs: { title: "Countries" },
                      },
                      [
                        _c("ProfileCountrySelect", {
                          attrs: {
                            getcontainerStyle: "customFullWidthInput",
                            multiple: "",
                          },
                          model: {
                            value: _vm.filterFields.countries,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterFields, "countries", $$v)
                            },
                            expression: "filterFields.countries",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-2 gap-6" },
                      [
                        _c(
                          "FormGroup",
                          {
                            staticClass: "city_input from-group jb-desgin",
                            attrs: { title: "Cities" },
                          },
                          [
                            _c("UserCityMultiselect", {
                              attrs: {
                                country: _vm.countriesNames,
                                state: _vm.statesNames,
                                placeholder: "Select Cities",
                              },
                              model: {
                                value: _vm.filterFields.cities,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterFields, "cities", $$v)
                                },
                                expression: "filterFields.cities",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("RegionInput", {
                          staticClass: "mb-4",
                          attrs: {
                            countries: _vm.filterFields.countries,
                            multiple: "",
                            isIcon: false,
                            groupClasses: "state_input from-group",
                            title: "Region",
                            placeholder: !!_vm.filterFields.countries?.length
                              ? "Select Regions"
                              : "Search by Region",
                            shouldFullWidth: "customFullWidthInput",
                            getcontainerStyle: "customFullWidthInput",
                          },
                          model: {
                            value: _vm.filterFields.states,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterFields, "states", $$v)
                            },
                            expression: "filterFields.states",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "mb-5" },
                      [
                        _c(
                          "FormGroup",
                          {
                            staticClass: "from-group jb-desgin",
                            attrs: { title: "Titles" },
                          },
                          [
                            _c("TitlesMultiselect", {
                              model: {
                                value: _vm.filterFields.titles,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterFields, "titles", $$v)
                                },
                                expression: "filterFields.titles",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "flex flex-col gap-2" }, [
                      _c("p", [_vm._v("Time Range")]),
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-6" },
                        [
                          _c(
                            "FormGroup",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                name: "start_date",
                                inputClass: "border-lg rounded-m",
                                id: "startDate",
                              },
                            },
                            [
                              _c("FormDatepicker", {
                                attrs: {
                                  name: "start date",
                                  placeholder: "Select start date",
                                  isCalenderIcon: true,
                                },
                                model: {
                                  value: _vm.rangeStart,
                                  callback: function ($$v) {
                                    _vm.rangeStart = $$v
                                  },
                                  expression: "rangeStart",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                name: "end_date",
                                inputClass: "border-lg rounded-m",
                                id: "endDate",
                              },
                            },
                            [
                              _c("FormDatepicker", {
                                attrs: {
                                  name: "end date",
                                  placeholder: "Select end date",
                                  isCalenderIcon: true,
                                },
                                model: {
                                  value: _vm.rangeEnd,
                                  callback: function ($$v) {
                                    _vm.rangeEnd = $$v
                                  },
                                  expression: "rangeEnd",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mb-5" },
                      [
                        _c(
                          "FormGroup",
                          {
                            staticClass: "from-group jb-desgin",
                            attrs: { title: "Skills" },
                          },
                          [
                            _c("SkillsMultiselect", {
                              attrs: { multiple: "" },
                              on: { inputSkills: _vm.setSkills },
                              model: {
                                value: _vm.filterFields.skills,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterFields, "skills", $$v)
                                },
                                expression: "filterFields.skills",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "FormGroup",
                  { staticClass: "from-group", attrs: { title: "Rates" } },
                  [
                    _c("InputRangeFilter", {
                      attrs: {
                        inputClasses: "px-6 placeholder-normal ",
                        suffix: "$",
                        suffixClasses: "text-lg",
                        minValue: _vm.filterFields.minRate,
                        maxValue: _vm.filterFields.maxRate,
                      },
                      on: {
                        "update:minValue": function ($event) {
                          return _vm.$set(_vm.filterFields, "minRate", $event)
                        },
                        "update:min-value": function ($event) {
                          return _vm.$set(_vm.filterFields, "minRate", $event)
                        },
                        "update:maxValue": function ($event) {
                          return _vm.$set(_vm.filterFields, "maxRate", $event)
                        },
                        "update:max-value": function ($event) {
                          return _vm.$set(_vm.filterFields, "maxRate", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex justify-end pt-5" },
                  [
                    _c("UIButton", {
                      staticClass: "mr-3",
                      attrs: {
                        variant: "outline",
                        buttonText: "Reset",
                        size: "sm",
                      },
                      on: { click: _vm.clearFilters },
                    }),
                    _c("UIButton", {
                      attrs: {
                        buttonText: "Apply Filters",
                        size: "sm",
                        variant: "black",
                      },
                      on: { click: _vm.applyFilters },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }